// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3pkth","controls":"styles_controls__2Mcar","button":"styles_button__2r7US","divider":"styles_divider__3v6hr","form":"styles_form__1lMSN"};